import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from "../Skeleton";
import IconSelector from "./IconSelector";
import { icons } from "./helpers";
export function Icon({ alt, name, size = "24px", color, hasPermission = true, loading, fill = false, sizeIgnoreHeight, grade = 0, opticalSize = 24, rounded = true, weight = 400, display, margin, padding, visibility, className, }) {
    const classType = `material-symbols-${rounded ? "rounded" : "outlined"}`;
    const commonProps = {
        name,
        size,
        classType,
        className,
        "aria-label": alt || icons[name]?.alt,
        "data-testid": `icon-${name}-${size}`,
        color: !hasPermission ? "--text-primary" : color || "--text-primary",
        sizeIgnoreHeight,
        materialSymbols: { fill, grade, opticalSize, rounded, weight },
        flexParams: { display, margin, padding, visibility },
        "data-icon-name": `${name}-icon`,
    };
    if (loading)
        return _jsx(Skeleton, { width: size, height: size });
    return _jsx(IconSelector, { ...commonProps });
}
//# sourceMappingURL=index.js.map